<template>
  <div class="teaching-score-grade-main"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="configInfo">
      <AppScrollbar style="height: 100%">
        <div class="main-cont">
          <div class="config-tip">
            <div class="tip-text">
              <span class="theme-text">温馨提示</span>
            </div>
            <div class="tip-cont">
              <ul>
                <li>1、当前仅支持两种等级评分制的规则设置，分别为二级评分制和五级评分制；</li>
                <li>2、为保证等级换算的准确度，建议录分时输入百分制分数；</li>
                <li>3、对应的分数区间：录分为百分制，显示结果需要等级制，则根据对应分数区间的设置进行转换；</li>
                <li>4、转换出的分数：录分为等级，显示结果需要百分制，则根据转换出的分数进行显示；</li>
              </ul>
            </div>
          </div>
          <div v-if="configForm"
               class="config-info">
            <template v-if="configForm.scoreGrades && configForm.scoreGrades.length">
              <div v-for="scoreGrade in configForm.scoreGrades"
                   :key="scoreGrade.code"
                   class="config-form">
                <div class="title">
                  <TitleGroup :title="`${scoreGrade.name}分值规则`"></TitleGroup>
                </div>
                <div class="form-cont">
                  <DataGrid size="mini"
                            border="none"
                            height="auto"
                            :data="scoreGrade.options">
                    <DataGridColumn title="对应的分数区间(分)"
                                    align="center"
                                    min-width="240">
                      <template #default="{row, rowIndex, data}">
                        <TeachingScoreGradeInputRange :current="row"
                                                      :prev="data[rowIndex - 1]"
                                                      :next="data[rowIndex + 1]"
                                                      :min-score="configInfo.minScore"
                                                      :max-score="configInfo.maxScore"
                                                      :disabled="row.maxDisabled || !editMode"></TeachingScoreGradeInputRange>
                      </template>
                    </DataGridColumn>
                    <DataGridColumn :title="scoreGrade.name"
                                    align="center"
                                    width="160">
                      <template #default="{row, rowIndex, data}">
                        <TeachingScoreGradeInputLabel :current="row"
                                                      :next="data[rowIndex + 1]"
                                                      :min-score="configInfo.minScore"
                                                      :max-score="configInfo.maxScore"></TeachingScoreGradeInputLabel>
                      </template>
                    </DataGridColumn>
                    <DataGridColumn title="转换出的分数(分)"
                                    align="center"
                                    min-width="180">
                      <template #default="{row, rowIndex, data}">
                        <TeachingScoreGradeInputConvert :current="row"
                                                        :next="data[rowIndex + 1]"
                                                        :min-score="configInfo.minScore"
                                                        :max-score="configInfo.maxScore"
                                                        :disabled="!editMode"></TeachingScoreGradeInputConvert>

                      </template>
                    </DataGridColumn>
                  </DataGrid>
                </div>
              </div>
            </template>
            <div class="config-form">
              <div class="title">
                <TitleGroup title="百分制分数显示方式"></TitleGroup>
              </div>
              <div class="form-cont">
                <el-form size="mini"
                         label-width="160px">
                  <el-form-item label="百分制成绩是否显示小数">
                    <el-radio-group v-if="editMode"
                                    v-model="configForm.displayFraction">
                      <el-radio label="0">不显示</el-radio>
                      <el-radio label="1">显示</el-radio>
                    </el-radio-group>
                    <el-radio-group v-else
                                    :value="configForm.displayFraction || '0'"
                                    disabled>
                      <el-radio label="0">不显示</el-radio>
                      <el-radio label="1">显示</el-radio>
                    </el-radio-group>
                    <div class="tip-msg">
                      <span>注：不显示情况下，百分制成绩取整数将进行“四舍五入</span>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </AppScrollbar>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>分数评分制设置加载失败</div>
        <el-button type="text"
                   @click="loadConfigInfo">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../elements/AppScrollbar'
import TitleGroup from '../../../../../../widgets/custom/TitleGroup'
import DataGrid from '../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../elements/DataGridColumn'
import TeachingScoreGradeInputRange from './input/range'
import TeachingScoreGradeInputLabel from './input/label'
import TeachingScoreGradeInputConvert from './input/convert'
import Hint from '../../../../../../elements/Hint'
import objectUtils from '../../../../../../../util/objectUtils'
export default {
  name: 'TeachingScoreGradeMain',
  components: {
    AppScrollbar,
    TitleGroup,
    DataGrid,
    DataGridColumn,
    TeachingScoreGradeInputRange,
    TeachingScoreGradeInputLabel,
    TeachingScoreGradeInputConvert,
    Hint
  },
  props: {
    editMode: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      configInfo: null,
      form: {
        scoreGrades: [],
        displayFraction: ''
      }
    }
  },
  computed: {
    configForm () {
      return this.editMode ? this.form : this.configInfo
    }
  },
  methods: {
    loadConfigInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/score/grade/configInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.configInfo = response.data['configInfo'] || {}
              this.$emit('ready')
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    initialForm () {
      let configInfo = this.configInfo || {}
      Object.keys(this.form).forEach(key => {
        let getVal = this.form[key]
        if (Array.isArray(getVal)) {
          this.form[key] = objectUtils.clone(configInfo[key] || [], true)
        } else {
          this.form[key] = configInfo[key]
        }
      })
    },
    getConfigInfo () {
      return new Promise((resolve, reject) => {
        let scoreGrades = this.form.scoreGrades
        if (scoreGrades) {
          let isValid = scoreGrades.every(scoreGrade => {
            let options = scoreGrade.options || []
            return options.every(option => {
              if (!option.maxDisabled) {
                const getMaximum = option.maximum
                if (!objectUtils.hasValue(getMaximum)) {
                  reject(new Error(`${scoreGrade.name}-${option.name}：分数区间未设置`))
                  return false
                }
                if (option['$rangeError']) {
                  reject(new Error(`${scoreGrade.name}-${option.name}：分数区间配置错误`))
                  return false
                }
              }
              const getConvert = option.convert
              if (!objectUtils.hasValue(getConvert)) {
                reject(new Error(`${scoreGrade.name}-${option.name}：转换分数未设置`))
                return false
              }
              if (option['$convertError']) {
                reject(new Error(`${scoreGrade.name}-${option.name}：转换分数配置错误`))
                return false
              }
              return true
            })
          })
          if (!isValid) {
            return
          }
        }
        if (!this.form.displayFraction) {
          reject(new Error('请设置百分制成绩是否显示小数'))
          return
        }
        resolve({
          result: this.form,
          resolve: () => this.loadConfigInfo()
        })
      })
    }
  },
  mounted () {
    this.loadConfigInfo()
  },
  watch: {
    configInfo: function (val) {
      if (val) {
        this.initialForm()
      }
    },
    editMode: function (val) {
      if (val) {
        this.initialForm()
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../styles/color";
  .teaching-score-grade-main {
    height: 100%;
    .main-cont {
      margin: auto;
      width: 640px;
      max-width: 100%;
      padding: 30px 15px;
      box-sizing: border-box;
      & > .config-tip {
        & > .tip-text {
          font-size: 12px;
          padding-bottom: 10px;
        }
        & > .tip-cont {
          ul {
            list-style: none;
            margin: 0;
            padding: 0;
            & > li {
              color: #606266;
              font-size: 12px;
              & + li {
                margin-top: 6px;
              }
            }
          }
        }
      }
      & > .config-info {
        margin-top: 20px;
        & > .config-form {
          border-top: 1px solid #ebeef5;
          padding-top: 20px;
          & > .title {
            font-size: 12px;
            margin-bottom: 15px;
          }
          & > .form-cont {
            .vxe-table {
              .vxe-table--header-wrapper {
                .vxe-table--header {
                  margin-bottom: 10px;
                  .vxe-header--row {
                    background-color: #f9f9fa;
                  }
                }
              }
              .vxe-table--body-wrapper {
                .vxe-table--body {
                  .vxe-body--row {
                    .vxe-body--column {
                      .el-input-number {
                        width: 90px;
                        &.is-disabled {
                          .el-input__inner {
                            color: #606266!important;
                          }
                        }
                        &.is-error {
                          .el-input__inner {
                            border-color: $set-danger-color!important;
                          }
                        }
                        .el-input__inner {
                          padding-left: 5px;
                          padding-right: 32px;
                          border-radius: 0;
                        }
                      }
                    }
                  }
                }
              }
            }
            .el-form {
              .el-form-item {
                .el-form-item__label {
                  padding-right: 16px;
                  font-size: 12px;
                }
                .el-form-item__content {
                  .el-radio-group {
                    .el-radio {
                      &.is-checked {
                        &.is-disabled {
                          .el-radio__label {
                            color: #606266!important;
                          }
                        }
                      }
                      .el-radio__label {
                        font-size: 12px;
                      }
                    }
                  }
                  .tip-msg {
                    color: #909399;
                    font-size: 12px;
                  }
                }
              }
            }
          }
          & + .config-form {
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>
